module.exports = __webpack_public_path__ + "src/assets/static/img/footer-brand-3.644ce4cd.png";